import { Box } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import React, { useEffect, useState } from "react";
import { Fade } from "react-awesome-reveal";

import About from "./About";
import Certificates from "./Certificates";
import Contact from "./Contact";
import GitHubStats from "./GitHubStats";
import NavBar from "./NavBar";
import Projects from "./Projects";

export default function MainPage(props) {
  const isMobile = useMediaQuery("(max-width: 700px)");

  const [aboutRef] = useState(React.createRef());
  const [certificatesRef] = useState(React.createRef());
  const [projectsRef] = useState(React.createRef());
  const [demosRef] = useState(React.createRef());
  const [contactRef] = useState(React.createRef());
  const [navBarRef] = useState(React.createRef());

  const [aboutAnime, setAboutAnime] = useState(true);
  const [certificatesAnime, setCertificatesAnime] = useState(false);
  const [projectsAnime, setProjectsAnime] = useState(false);
  const [, setDemosAnime] = useState(false);
  const [contactAnime, setContactAnime] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const getOffset = () =>
    (navBarRef?.current?.clientHeight ?? 0) + (isMobile ? 12 : 24);

  const scrollToSection = (ref, setAnime) => {
    if (ref?.current?.offsetTop != null)
      window.scrollTo({
        top: ref.current.offsetTop - getOffset(),
        behavior: "smooth",
      });
    setAnime(true);
  };

  return (
    <Box style={{ width: "100vw", minHeight: "100vh" }}>
      <Box ref={navBarRef} style={{ position: "sticky", top: 0, zIndex: 1000 }}>
        <NavBar
          scrollToAbout={() => scrollToSection(aboutRef, setAboutAnime)}
          scrollToCertificates={() =>
            scrollToSection(certificatesRef, setCertificatesAnime)
          }
          scrollToProjects={() =>
            scrollToSection(projectsRef, setProjectsAnime)
          }
          scrollToDemos={() => scrollToSection(demosRef, setDemosAnime)}
          scrollToContact={() => scrollToSection(contactRef, setContactAnime)}
        />
      </Box>
      <Box
        style={{
          padding: isMobile ? "24px 16px" : "48px 24px",
          overflowX: "hidden",
        }}
      >
        <Box sx={{ maxWidth: "80vw", width: "100%", mx: "auto" }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 8 }}>
            <Box ref={aboutRef}>
              <Fade triggerOnce spy={aboutAnime}>
                <About />
              </Fade>
            </Box>
            <Box ref={certificatesRef}>
              <Fade triggerOnce spy={certificatesAnime}>
                <Certificates />
              </Fade>
            </Box>
            <Box ref={projectsRef}>
              <Fade triggerOnce spy={projectsAnime}>
                <Projects />
              </Fade>
            </Box>
            {/* <Box ref={demosRef}>
              <Fade triggerOnce spy={demosAnime}>
                <Demos />
              </Fade>
            </Box> */}
            <Box>
              <Fade triggerOnce>
                <GitHubStats />
              </Fade>
            </Box>
            <Box ref={contactRef} style={{ paddingBottom: "40px" }}>
              <Fade triggerOnce spy={contactAnime}>
                <Contact />
              </Fade>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
